export default {
  maxWidth: {
    sm: 420,
    md: 720,
    lg: 1040,
  },
}
